module.exports = __webpack_public_path__ + "img/georgina-moreno.abdf121e.png";